// Add your custom JS here.





var controller = new ScrollMagic.Controller();

// build tween

//var tween = TweenMax.from("#cita-taller", 0.5, {autoAlpha: 0, scale: 0.7});



(function($){



    // change behaviour of controller to animate scroll instead of jump

	/*controller.scrollTo(function (newpos) {

		TweenMax.to(window, 0.5, {scrollTo: {y: newpos}});

	});*/



//  Bind scroll to anchor links

$(document).on("click", "a[href^='#']", function (e) {

    var id = $(this).attr("href");

    if ($(id).length > 0) {

        e.preventDefault();



        // trigger scroll

        controller.scrollTo(id);



            // if supported by the browser we can even update the URL.

        if (window.history && window.history.pushState) {

            history.pushState("", document.title, id);

        }

    }

});

})( jQuery );



(function($){

    $(document).ready(function($){

        

        $('.btn-vermas').click(function () {
            var $this = $(this);
            //$this.toggleClass('collapsed');
            if($this.hasClass('collapsed')){
                $this.text('Ver más');         
            } else {
                $this.text('Ver menos');
            }
        });   


        
        $('article.card').each(function () {

            var card = $(this);

            var id = card.attr('id');

            // build scene

            new ScrollMagic.Scene({

                triggerElement: "#" + id,

                triggerHook: 0.7,

                offset: 50, // move trigger to center of element

            })

            .setClassToggle("#"+id, "visible") // add class toggle

            .addTo(controller);

        });



        $('.cajamagic').each(function () {

            var card = $(this);

            var id = card.attr('id');

            // build scene

            new ScrollMagic.Scene({

                triggerElement: "#" + id,

                triggerHook: 0.9,

                offset: 90, // move trigger to center of element

            })

            .setClassToggle("#"+id, "visible") // add class toggle

            .addTo(controller); 

        });


      //var Sticky = require('sticky-js');
      var sticky = new Sticky('#trigger1'); 
      //var sticky = new Sticky('.data-sticky-container');
      var sticky = new Sticky('.hace-sticky'); 


    });

})( jQuery );

(function($){

 

//  Bind scroll to anchor links
$(document).on("click", "a[href^='#']", function (e) {
    var id = $(this).attr("href");
    if ($(id).length > 0) {
        e.preventDefault();

        // trigger scroll
        controller.scrollTo(id);

            // if supported by the browser we can even update the URL.
        if (window.history && window.history.pushState) {
            history.pushState("", document.title, id);
        }
    }
});
})( jQuery );

(function($){

    // Get and autoplay Video from data
function autoPlayYouTubeModal() {
    var triggerOpen = $("body").find('[data-tagVideo]');
    triggerOpen.click(function() {
      var theModal = $(this).data("bs-target"),
        videoSRC = $(this).attr("data-tagVideo"),
        videoSRCauto = videoSRC + "?autoplay=1";
      $(theModal + ' iframe').attr('src', videoSRCauto);
      $(theModal + ' button.btn-close').click(function() {
        $(theModal + ' iframe').attr('src', videoSRC);
      });
    });
  }
  


    $(document).ready(function($){

        autoPlayYouTubeModal();

        /*js para menu fijo*/
        const body = document.body;
        const nav = document.querySelector("#topbar");
        const menu = document.querySelector(".widget");
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;
        
        window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll == 0) {
            body.classList.remove(scrollUp);
            return;
        }
        
        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
        });
        /*****/

        $('article.card').each(function () {
            var card = $(this);
            var id = card.attr('id');
            // build scene
            new ScrollMagic.Scene({
                triggerElement: "#" + id,
                triggerHook: 0.7,
                offset: 50, // move trigger to center of element
            })
            .setClassToggle("#"+id, "visible") // add class toggle
            .addTo(controller);
        });

        $('.cajamagic').each(function () {
            var card = $(this);
            var id = card.attr('id');
            // build scene
            new ScrollMagic.Scene({
                triggerElement: "#" + id,
                triggerHook: 0.7,
                offset: 50, // move trigger to center of element
            })
            .setClassToggle("#"+id, "visible") // add class toggle
            .addTo(controller); 
        });


    });
})( jQuery );